<template>
  <div class="chzzk-chatting-panel__root">
    <!-- <chat-parser></chat-parser> -->
    <div class="live_chatting_container__SvtrD">
      <div class="live_chatting_list_container__vwsbZ live_chatting_list_exist_fixed_message__2EP21" role="log">
        <div class="live_chatting_list_wrapper__a5XTV" style="width: 100%">
          <div class="live_chatting_list_item__0SGhw">
            <div class="live_chatting_message_container__vrI-y">
              <one-chat v-for="(chatData, i) in chatDatas" :data="chatData" :key="i"></one-chat>
            </div>
          </div>
        </div>
      </div>
      <div v-show="showInput" class="live_chatting_area__hUPJw">
        <!-- style="background-color: #1e1135" -->
        <div class="live_chatting_input_container__qA0ad">
          <button type="button" class="live_chatting_input_setting_button__u9WRl" aria-label="내 사용중인 프로필 팝업">
            <i class="live_chatting_input_icon_setting__TshVj"
              ><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.8337 10.3199C14.8038 10.7098 14.9535 11.0998 15.2631 11.3597L15.8023 11.8096C15.992 11.9696 16.0519 12.2295 15.9521 12.4495C15.7424 12.9194 15.4828 13.3593 15.1732 13.7593C15.0234 13.9492 14.7638 14.0292 14.5242 13.9492L13.8452 13.7193C13.4558 13.5893 13.0364 13.6593 12.6969 13.8792C12.5172 13.9992 12.3275 14.1092 12.1278 14.1992C11.7583 14.3691 11.4887 14.6891 11.4088 15.079L11.279 15.7689C11.2291 16.0088 11.0394 16.1888 10.7898 16.2188C10.5302 16.2488 10.2706 16.2688 10.001 16.2688C9.73136 16.2688 9.47175 16.2488 9.21213 16.2188C8.96251 16.1888 8.77279 16.0088 8.72287 15.7689L8.59306 15.079C8.51318 14.6891 8.24358 14.3791 7.87413 14.1992C7.67443 14.0992 7.48472 13.9992 7.30499 13.8792C6.96549 13.6593 6.54612 13.5893 6.1567 13.7193L5.47772 13.9492C5.23808 14.0292 4.97847 13.9492 4.82869 13.7593C4.51915 13.3593 4.25954 12.9194 4.04985 12.4495C3.95 12.2295 4.00991 11.9696 4.19963 11.8096L4.73882 11.3597C5.04836 11.1098 5.19814 10.7198 5.16818 10.3199C5.1582 10.2099 5.1582 10.1099 5.1582 9.99997C5.1582 9.94498 5.16069 9.89249 5.16319 9.84C5.16569 9.78751 5.16818 9.73502 5.16818 9.68003C5.19814 9.29011 5.04836 8.90018 4.73882 8.64023L4.19963 8.19031C4.00991 8.03034 3.95 7.77039 4.04985 7.55044C4.25954 7.08052 4.51915 6.64061 4.82869 6.24068C4.97847 6.05072 5.23808 5.97074 5.47772 6.05072L6.1567 6.28068C6.54612 6.41065 6.96549 6.34067 7.30499 6.12071C7.48472 6.00073 7.67443 5.89075 7.87413 5.80077C8.24358 5.6308 8.51318 5.31086 8.59306 4.92093L8.72287 4.23107C8.77279 3.99111 8.96251 3.81115 9.21213 3.78115C9.47175 3.75116 9.73136 3.73116 10.001 3.73116C10.2706 3.73116 10.5302 3.75116 10.7898 3.78115C11.0394 3.81115 11.2291 3.99111 11.279 4.23107L11.4088 4.92093C11.4887 5.31086 11.7583 5.6308 12.1278 5.80077C12.3275 5.90075 12.5172 6.00073 12.6969 6.12071C13.0364 6.34067 13.4558 6.41065 13.8452 6.28068L14.5242 6.05072C14.7638 5.97074 15.0234 6.05072 15.1732 6.24068C15.4828 6.64061 15.7424 7.08052 15.9521 7.55044C16.0519 7.77039 15.992 8.03034 15.8023 8.19031L15.2631 8.64023C14.9535 8.89018 14.8038 9.28011 14.8337 9.68003C14.8437 9.79001 14.8437 9.88999 14.8437 9.99997C14.8437 10.055 14.8412 10.1074 14.8387 10.1599C14.8362 10.2124 14.8337 10.2649 14.8337 10.3199ZM16.3378 9.69667C16.3435 9.81224 16.3435 9.9126 16.3434 9.98509L16.3434 9.99997C16.3434 10.0914 16.3394 10.1748 16.3371 10.2238L16.3367 10.2312C16.3351 10.2661 16.3342 10.2863 16.3338 10.2999L16.769 10.6631C17.4575 11.2436 17.7012 12.2178 17.3202 13.0637C17.065 13.6351 16.7456 14.178 16.3592 14.6772L16.351 14.6878C15.807 15.3777 14.8849 15.6507 14.0494 15.3718L14.0431 15.3697L13.4602 15.1723C13.2758 15.2919 13.073 15.4098 12.8527 15.5158L12.7502 16.0603L12.7473 16.0744C12.5689 16.9319 11.8705 17.5994 10.9687 17.7078L10.9619 17.7086C10.6648 17.7429 10.3449 17.7685 10.001 17.7685C9.65698 17.7685 9.33712 17.7429 9.04001 17.7086L9.03322 17.7078C8.13145 17.5995 7.43302 16.9319 7.25459 16.0744L7.25167 16.0603L7.14869 15.513C6.96756 15.4215 6.75688 15.3102 6.54199 15.1722L5.95253 15.3718C5.11697 15.6507 4.19494 15.3777 3.651 14.6878L3.64266 14.6772C3.25631 14.1781 2.93694 13.6351 2.68171 13.0638C2.30071 12.2178 2.54438 11.2436 3.23287 10.6631L3.23878 10.6581L3.66407 10.3033C3.65841 10.1877 3.65845 10.0873 3.65848 10.0149C3.65848 10.0098 3.65848 10.0048 3.65848 9.99997C3.65848 9.90858 3.66247 9.8252 3.66481 9.77615L3.66517 9.76876C3.66683 9.73382 3.66769 9.71362 3.66811 9.70004L3.23286 9.33686C2.54435 8.7563 2.30069 7.78208 2.68175 6.93607C2.93697 6.36477 3.25637 5.8219 3.64271 5.32275L3.65095 5.3121C4.19489 4.62222 5.11697 4.34927 5.95253 4.62815L5.9588 4.63025L6.54174 4.82769C6.72614 4.708 6.92893 4.5901 7.14922 4.48414L7.25167 3.93963L7.25459 3.92557C7.43302 3.068 8.13145 2.4005 9.03322 2.29215L9.04001 2.29133C9.33712 2.257 9.65698 2.23145 10.001 2.23145C10.3449 2.23145 10.6648 2.25702 10.9619 2.29135L10.9687 2.29213C11.8705 2.40048 12.5689 3.068 12.7473 3.92557L12.7502 3.93963L12.8532 4.48691C13.0343 4.57841 13.245 4.68975 13.4599 4.82777L14.0494 4.62814C14.8849 4.34925 15.807 4.62226 16.3509 5.31214L16.3592 5.32271C16.7456 5.82187 17.065 6.36479 17.3202 6.93611C17.7012 7.7821 17.4575 8.75629 16.769 9.33684L16.7631 9.34183L16.3378 9.69667Z"
                  fill="currentColor"
                ></path>
                <ellipse
                  cx="10.0019"
                  cy="10.0228"
                  rx="2.0996"
                  ry="2.0996"
                  stroke="currentColor"
                  stroke-width="1.2"
                ></ellipse></svg
            ></i></button
          ><input
            v-model="inputMessage"
            class="live_chatting_input_input__2F3Et live_chatting_input_default__HjSyH"
            placeholder="채팅을 입력해주세요"
            style="height: 40px !important"
          />
          <button
            type="button"
            class="live_chatting_input_input_button__sjwrf"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="후원"
          >
            <span class="live_chatting_input_discount__guhdC"
              >치즈로 후원하기!<svg
                width="7"
                height="5"
                viewBox="0 0 9 7"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="live_chatting_input_tail__wWCrz"
                aria-hidden="true"
              >
                <path
                  d="M9 0H0L3.40647 5.29895C3.9182 6.09497 5.08181 6.09497 5.59353 5.29895L9 0Z"
                  fill="currentColor"
                ></path></svg></span
            ><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
              <path
                d="M23.1235 12.7878L18.7093 7.28617C18.5841 7.13235 18.4017 7.03577 18.2014 7.02504C17.883 7.01073 17.5611 7 17.2391 7C13.5977 7 10.1922 8.00874 7.28406 9.76153L23.1199 12.7842L23.1235 12.7878ZM15.3254 8.11963C16.2304 8.11963 16.9637 8.438 16.9637 8.83148C16.9637 9.22496 16.2304 9.54332 15.3254 9.54332C14.4204 9.54332 13.6871 9.22496 13.6871 8.83148C13.6871 8.438 14.4204 8.11963 15.3254 8.11963Z"
                fill="currentColor"
              ></path>
              <path
                d="M11.0902 12.3412C11.0866 12.3662 11.0831 12.3877 11.0759 12.4127C10.9221 13.053 10.0743 13.5109 9.34817 13.3678C8.70429 13.239 8.27146 12.7883 8.23569 12.2589C8.22496 12.1051 8.25358 11.9513 8.31797 11.8117L6.12162 11.3896C6.04293 12.6559 6 13.933 6 15.2207C6 16.5085 6.04293 17.8821 6.12878 19.1985C6.15739 19.6492 6.49364 20.0212 6.9372 20.1071L11.0545 20.894C11.058 20.8475 11.0688 20.801 11.0831 20.7545C11.2548 20.1929 12.0668 19.9604 12.8573 20.2358C13.5191 20.4648 13.9269 20.9727 13.8875 21.4342L23.1737 23.2084C23.6029 23.2907 24 22.9616 24 22.5252V14.8058L11.0902 12.3412ZM21.0346 19.0768C20.7627 19.8245 19.8362 20.1214 18.9599 19.7422C18.0799 19.3594 17.5862 18.4365 17.8617 17.6854C18.1371 16.9306 19.0779 16.6373 19.9543 17.0272C20.8271 17.4135 21.3064 18.3328 21.0346 19.0768Z"
                fill="currentColor"
              ></path>
            </svg></button
          ><button
            type="button"
            class="live_chatting_input_input_button__sjwrf"
            aria-haspopup="true"
            aria-expanded="false"
            aria-label="이모티콘"
          >
            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15 25C20.5228 25 25 20.5228 25 15C25 9.47715 20.5228 5 15 5C9.47715 5 5 9.47715 5 15C5 20.5228 9.47715 25 15 25Z"
                stroke="currentColor"
                stroke-width="1.8"
              ></path>
              <path
                d="M12.4363 11.021H12.2669C11.729 11.021 11.293 11.4403 11.293 11.9575V13.1383C11.293 13.6555 11.729 14.0748 12.2669 14.0748H12.4363C12.9742 14.0748 13.4103 13.6555 13.4103 13.1383V11.9575C13.4103 11.4403 12.9742 11.021 12.4363 11.021Z"
                fill="currentColor"
              ></path>
              <path
                d="M17.7293 11.021H17.5599C17.022 11.021 16.5859 11.4403 16.5859 11.9575V13.1383C16.5859 13.6555 17.022 14.0748 17.5599 14.0748H17.7293C18.2672 14.0748 18.7032 13.6555 18.7032 13.1383V11.9575C18.7032 11.4403 18.2672 11.021 17.7293 11.021Z"
                fill="currentColor"
              ></path>
              <path
                d="M18.9846 17.493L19.6552 17.6939L18.9846 17.493ZM15.0002 18.8998C14.1137 18.8998 13.323 18.6957 12.7315 18.3792C12.1309 18.0578 11.7956 17.6567 11.6864 17.2921L10.3453 17.6939C10.5956 18.5293 11.2637 19.1816 12.071 19.6136C12.8874 20.0505 13.9092 20.2998 15.0002 20.2998V18.8998ZM18.3141 17.2921C18.2048 17.6567 17.8696 18.0578 17.269 18.3792C16.6775 18.6957 15.8868 18.8998 15.0002 18.8998V20.2998C16.0913 20.2998 17.1131 20.0505 17.9295 19.6136C18.7368 19.1816 19.4049 18.5293 19.6552 17.6939L18.3141 17.2921ZM18.5575 16.3H11.443V17.7H18.5575V16.3ZM19.6552 17.6939C19.7722 17.3034 19.6528 16.9294 19.4218 16.6758C19.2012 16.4338 18.8839 16.3 18.5575 16.3V17.7C18.5072 17.7 18.4431 17.6804 18.387 17.6188C18.3571 17.586 18.3272 17.538 18.3114 17.4752C18.2949 17.41 18.2981 17.3455 18.3141 17.2921L19.6552 17.6939ZM11.6864 17.2921C11.7024 17.3455 11.7055 17.41 11.6891 17.4752C11.6733 17.538 11.6434 17.586 11.6135 17.6188C11.5574 17.6804 11.4932 17.7 11.443 17.7V16.3C11.1166 16.3 10.7992 16.4338 10.5787 16.6758C10.3477 16.9294 10.2283 17.3034 10.3453 17.6939L11.6864 17.2921Z"
                fill="currentColor"
              ></path>
            </svg>
          </button>
        </div>
        <div class="live_chatting_input_tools__OPA1R">
          <!-- style="background-color: #1e1135" -->
          <button
            type="button"
            id="send_chat_or_donate"
            class="live_chatting_input_send_button__8KBrn"
            :class="{ live_chatting_input_is_active__WeOjk: this.inputMessage }"
            @click="appendTestMessage(inputMessage)"
          >
            채팅
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OneChat from "../OneChat.vue";

//
export default {
  name: "ChzzkChattingPanel",
  components: { OneChat },
  props: {
    // 하단 채팅 입력부(입력창+버튼) 표시 여부. 숏폼 환경설정에서 토글.
    showInput: { type: Boolean, default: true },
  },
  data() {
    return {
      inputMessage: null,
      chatDatas: [],
    };
  },
  mounted() {
    this.scrollTargetEl = this.$el.querySelector(".live_chatting_list_item__0SGhw");

    // 한국어 입력시 이벤트 두번 트리거됨
    const eventTarget = this.$el.querySelector(".live_chatting_input_input__2F3Et");
    eventTarget.addEventListener("keydown", (event) => {
      if (event.isComposing || event.keyCode === 229) {
        return;
      }
      if (event.keyCode === 13) {
        this.appendTestMessage(event.target.value);
      }
    });
  },
  methods: {
    appendTestMessage(message) {
      this.$emit("onUserInput", message);
      this.inputMessage = null;
    },
    appendMessage(oneChat) {
      this.chatDatas.push(oneChat);

      this._scrollToBottom();
      this.$emit("on", oneChat);
    },
    _scrollToBottom() {
      this.$nextTick(() => {
        this.scrollTargetEl.scrollTop = this.scrollTargetEl.scrollHeight;
      });
    },
  },
};
</script>
<style src="./ChzzkChattingShortPanel.css" scoped></style>
